import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { API_PATH } from '@app/app.constants';
import { ResponsePurchases, ResponsePurchase } from '@app/_interfaces/responses';

export class MarketService {
    constructor(private api: APIService) {}

    getUserPurchases(): Observable<ResponsePurchases> {
        return this.api.get(API_PATH.market.user_purchases);
    }

    getPurchase(purchaseId: number): Observable<ResponsePurchase> {
        const url = `${API_PATH.market.user_purchase}${purchaseId}`;
        return this.api.get(url);
    }

    getSummaryDealProducts(productId: number): Observable<number> {
        const url = `${API_PATH.market.summary_deal_products}${productId}`;
        return this.api.get(url);
    }

    getMediumPrice(productId: number): Observable<number> {
        const url = `${API_PATH.market.medium_price}${productId}`;
        return this.api.get(url);
    }
}
